/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Private_Owner_OnlyInputs */



/**
* | output |
* | --- |
* | "This player kept their deck private. Only they can publish or replace it, from the Your Deck section of this tournament page" |
*
* @param {Err_Tournament_Deck_Private_Owner_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_private_owner_only = /** @type {((inputs?: Err_Tournament_Deck_Private_Owner_OnlyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Private_Owner_OnlyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce joueur a gardé son deck privé. Lui seul peut le publier ou le remplacer, depuis la section Votre deck de la page du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este jugador mantuvo su mazo privado. Solo él puede publicarlo o reemplazarlo, desde la sección Su Deck de la página del torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este jogador manteve seu deck privado. Somente ele pode publicá-lo ou substituí-lo, na seção Seu Deck da página do torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo giocatore ha tenuto il suo mazzo privato. Solo lui può pubblicarlo o sostituirlo, dalla sezione Il Tuo Deck della pagina del torneo")
	return /** @type {LocalizedString} */ ("This player kept their deck private. Only they can publish or replace it, from the Your Deck section of this tournament page")
});